<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="用户ID" :value="1"></el-option>
                            <el-option label="用户名称" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.auditStatus" placeholder="请选择处理状态" size="small">
                        <el-option :value="-1" :key="-1" label="不限审核状态"></el-option>
                        <el-option :value="1" :key="1" label="仅看待审核的"></el-option>
                        <el-option :value="2" :key="2" label="仅看已通过的"></el-option>
                        <el-option :value="3" :key="3" label="仅看已拒绝的"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="userId" label="用户ID"></el-table-column>
                <el-table-column prop="userName" label="用户名称"></el-table-column>
                <el-table-column label="角色">
                    <template slot-scope="scope">
                        <span v-if="scope.row.userType == 2">艺人</span>
                        <span v-else-if="scope.row.userType == 3">场地</span>
                        <span v-else-if="scope.row.userType == 5">厂牌</span>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="提交时间"></el-table-column>
                <el-table-column label="审核状态">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.auditStatus == 1" size="mini" type="danger">待审核</el-tag>
                        <el-tag v-else-if="scope.row.auditStatus == 2" size="mini" type="success">已通过</el-tag>
                        <el-tag v-else-if="scope.row.auditStatus == 3" size="mini" type="info">已拒绝</el-tag>
                    </template>
                </el-table-column>
                <el-table-column v-if="$utils.have('/baseInfoAudit/detail')" fixed="right" label="操作" width="80">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            :icon="scope.row.auditStatus == 1 ? 'el-icon-coordinate' : 'el-icon-view'"
                            @click="view(scope.row.auditId)"
                            >{{scope.row.auditStatus == 1 ? "审核" : "查看"}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0"
            >
            </el-pagination>
        </div>
        <detail-view ref="detailView" @onSuccess="getDataList"></detail-view>
    </div>
</template>
<script>
import DetailView from './components/detailView';
const defaultParams = {
    pageNo: 1,
    searchType: 1,
    searchValue: "",
    auditStatus: 1
}
export default {
    components:{DetailView},
    data() {
        return {
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageSize: this.$pageSizes[0],
            },
            listLoading: true
        };
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/baseInfoAudit/pageList",
                method: "POST",
                data: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //查看
        view(id) {
            this.$refs.detailView.show(id)
        }
    },
};
</script>

<style lang="scss" scoped>
.ellipsis{
    max-width:100%;
}
</style>